/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+5hP":
/***/ (function(module, exports) {

module.exports = {"header":{"title":"Shaffiullah Khan","subtitle":"I am a Full Stack Web Developer, I provide end to end solution for modern Web applications and cross-platform Mobile applications.","background_color":"#424242","background_image":"shaffidev.jpg","background_images":[{"width":2560,"filename":"https://res.cloudinary.com/shaffiullah-in/image/upload/v1522672289/c_imagga_crop/shaffi11.jpg"},{"width":1920,"filename":"https://res.cloudinary.com/shaffiullah-in/image/upload/v1522672289/c_imagga_crop/shaffi11.jpg"},{"width":1600,"filename":"https://res.cloudinary.com/shaffiullah-in/image/upload/v1522672289/c_imagga_crop/shaffi11.jpg"},{"width":1280,"filename":"https://res.cloudinary.com/shaffiullah-in/image/upload/v1522672289/c_imagga_crop/shaffi11.jpg"},{"width":960,"filename":"https://res.cloudinary.com/shaffiullah-in/image/upload/v1522672289/c_imagga_crop/shaffi11.jpg"},{"width":480,"filename":"https://res.cloudinary.com/shaffiullah-in/image/upload/v1522672289/c_imagga_crop/shaffi11.jpg"}]},"profile":{"title":"Profile","background_color":"#FFF","about":{"title":"About me","description":["A multi-disciplined software engineer who enjoys working on Fullstack JavaScript technologies with over 9 years worth of industrial experience. I strongly believe that having a crosstechnology knowledge enables me to approach technical challenges much more productively and  creatively - rather than be limited by a single technology’s way of thinking.","My core experience includes Node JS, Angular (1 and 2), JavaScript (ES6), Ionic and React. Additionally, I have extensive knowledge working with MongoDB, PostgreSQL, Docker and AWS"]},"bio":{"title":"Bio","list":[{"label":"How cool?","value":"Very cool."},{"label":"Where","value":"In the cloud..."}]}},"experience":{"title":"Experience","background_color":"#41564E","list":[{"title":"Principal Engineer","list":[{"location":"London, UK","time":{"from":"2013","to":"Present"},"title":"Causeway technologies","description":"Working as a full stack developer in R&D team, developing web and mobile application with modern web technologies. Leading projects to create Authenticated, Cacheable, RESTful, Rate-Limited API Gateways used across all products "}]},{"title":"What else?","list":[{"location":"Example","time":{"from":"Apr 2011","to":"Apr 2014"},"title":"Something else","description":"Some more stuff."},{"location":"Example","time":{"from":"Apr 2014"},"title":"Something else","description":"Some more stuff."},{"location":"Example","time":{"from":"Apr 2011","to":"Apr 2014"},"title":"Something else","description":"Some more stuff."},{"location":"Example","time":{"from":"Apr 2011","to":"Apr 2014"},"title":"Something else","description":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias vero blanditiis nemo deserunt tempora quidem consectetur natus unde illum ullam, harum suscipit commodi quas consequuntur? Repudiandae officiis minus tempora autem?"},{"location":"Example","time":{"from":"Apr 2011","to":"Apr 2014"},"title":"Something else","description":"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Laboriosam temporibus repellat ipsum, fugit labore vel qui vitae quos ratione iusto quam inventore et soluta, in, eveniet repellendus? Enim, quisquam autem!"},{"location":"Example","time":{"from":"Apr 2011","to":"Apr 2014"},"title":"Something else","description":"Some more stuff."}]}]},"skills":{"title":"Skills","background_color":"#FFF","list":[{"label":"Javascript","value":5},{"label":"Node JS","value":5},{"label":"Angular","value":5},{"label":"Docker","value":4}]},"contact":{"title":"Reach me at","background_color":"#607D8B","list":[{"label":"GitHub","link":"https://github.com/shaffi","icon_class":"github"},{"label":"Twitter","link":"https://twitter.com/shaffiullah","icon_class":"twitter"},{"label":"Linkedin","link":"https://www.linkedin.com/in/shaffiullah/","icon_class":"linkedin"},{"label":"Email","link":"mailto:mailforshaffi@gmail.com","icon_class":"envelope"}]}}

/***/ }),

/***/ "B7t3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d8f0ffe7c1237226cb62628c10890d36.jpg";

/***/ }),

/***/ "DrC8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4e65e214a3bbe510c9e37f58c91382bc.jpg";

/***/ }),

/***/ "JBMF":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./shaffi11-large.jpg": "k1am",
	"./shaffi11-medium.jpg": "B7t3",
	"./shaffi11-small.jpg": "DrC8",
	"./shaffi11-xlarge.jpg": "UdZ4",
	"./shaffi11-xsmall.jpg": "ZihT",
	"./shaffi11.jpg": "wTDx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JBMF";

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.scss
var style = __webpack_require__("yY49");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/unfetch/dist/unfetch.es.js
var unfetch_es = __webpack_require__("QAmr");

// CONCATENATED MODULE: ./components/icon.js

var icon_FaIcon = function FaIcon(_ref) {
	var icon = _ref.icon;
	return Object(preact_min["h"])("i", { "class": "fa fa-" + icon, "aria-hidden": "true" });
};

/* harmony default export */ var components_icon = (icon_FaIcon);
// CONCATENATED MODULE: ./components/home/header.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var header_FooterItem = function (_Component) {
  _inherits(FooterItem, _Component);

  function FooterItem() {
    _classCallCheck(this, FooterItem);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  FooterItem.prototype.render = function render(_ref) {
    var label = _ref.label,
        link = _ref.link,
        icon_class = _ref.icon_class;

    return Object(preact_min["h"])(
      'div',
      { 'class': 'social-link' },
      Object(preact_min["h"])(
        'a',
        { href: link, target: '_blank', rel: 'noopener noreferrer' },
        Object(preact_min["h"])(components_icon, { icon: icon_class }),
        ' ',
        label
      )
    );
  };

  return FooterItem;
}(preact_min["Component"]);

var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};
var social = [{
  label: 'GitHub',
  link: 'https://github.com/shaffi',
  icon_class: 'github'
}, {
  label: 'Twitter',
  link: 'https://twitter.com/shaffiullah',
  icon_class: 'twitter'
}, {
  label: 'Linkedin',
  link: 'https://www.linkedin.com/in/shaffiullah/',
  icon_class: 'linkedin'
}, {
  label: 'Email',
  link: 'mailto:mailforshaffi@gmail.com',
  icon_class: 'envelope'
}];
var viewSize = function viewSize() {
  var viewport = typeof window !== 'undefined' ? window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth : 1920,
      ratio = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;

  return { viewport: viewport, ratio: ratio };
};

var chooseBackgroundImages = function chooseBackgroundImages(backgroundImages, imageModules, _ref2) {
  var _ref2$viewport = _ref2.viewport,
      viewport = _ref2$viewport === undefined ? 1920 : _ref2$viewport,
      _ref2$ratio = _ref2.ratio,
      ratio = _ref2$ratio === undefined ? 1 : _ref2$ratio;

  var headerImage = void 0,
      imagesSized = backgroundImages.reduce(function (arr, image, i) {
    if (viewport * ratio < image.width) {
      image.filename = imageModules[i];
      arr.push(image);
    }

    return arr;
  }, []);
  if (imagesSized.length) {
    var lastImage = imagesSized.pop();
    if (lastImage && lastImage.filename) {
      headerImage = lastImage.filename;
    }
  } else {
    headerImage = imageModules[0];
  }

  return headerImage;
};
var determineImage = function determineImage(backgroundImage, backgroundImages) {
  var headerImage = void 0;
  if (backgroundImages) {
    var imageModules = requireAll(__webpack_require__("NfrT"));
    headerImage = chooseBackgroundImages(backgroundImages, imageModules, _extends({}, viewSize()));
  } else {
    headerImage = __webpack_require__("JBMF")("./" + backgroundImage);
  }

  if (headerImage) {
    return 'url(' + headerImage + ')';
  }
};

var header_Header = function (_Component2) {
  _inherits(Header, _Component2);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this2 = _possibleConstructorReturn(this, _Component2.call(this));

    _this2.state.background_image = 'http://res.cloudinary.com/shaffiullah-in/image/upload/s--MHfAhwog--/c_imagga_crop/v1522672289/shaffi11.jpg';

    return _this2;
  }

  Header.prototype.render = function render(props, _ref3) {
    var background_image = _ref3.background_image;

    return Object(preact_min["h"])(
      'header',
      {
        'class': 'header',
        style: {
          backgroundColor: props.background_color || null
        }
      },
      Object(preact_min["h"])(
        'div',
        { 'class': 'header-wrapper' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'header-wrapper-text' },
          Object(preact_min["h"])(
            'h1',
            { 'class': 'title', itemprop: 'name' },
            props.title
          ),
          Object(preact_min["h"])(
            'h2',
            { 'class': 'subtitle', itemprop: 'jobTitle' },
            props.subtitle
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': 'social' },
          social && social.map(function (item) {
            return Object(preact_min["h"])(header_FooterItem, item);
          })
        )
      )
    );
  };

  return Header;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/home/profile.js


function profile__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function profile__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function profile__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var profile__ref = Object(preact_min["h"])("div", { "class": "divider" });

var profile_Profile = function (_Component) {
	profile__inherits(Profile, _Component);

	function Profile() {
		profile__classCallCheck(this, Profile);

		return profile__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Profile.prototype.render = function render(props) {
		var bioList = [];
		if (props.bio && props.bio.list) {
			var bioLabels = props.bio.list.map(function (item) {
				return Object(preact_min["h"])(
					"li",
					{ key: item.label },
					Object(preact_min["h"])(
						"strong",
						null,
						item.label
					)
				);
			}),
			    bioValues = props.bio.list.map(function (item) {
				return Object(preact_min["h"])(
					"li",
					{ key: item.value },
					item.value
				);
			});

			bioList = bioLabels.reduce(function (list, item, i) {
				list.push(item, bioValues[i]);
				return list;
			}, []);
		}
		var descriptions = void 0;
		if (props.about.description.length) {
			descriptions = props.about.description.map(function (desc) {
				return Object(preact_min["h"])(
					"p",
					null,
					desc
				);
			});
		}
		return Object(preact_min["h"])(
			"main",
			{ "class": "main profile", style: { backgroundColor: props.background_color || null } },
			Object(preact_min["h"])(
				"div",
				{ "class": "main-wrapper" },
				Object(preact_min["h"])(
					"div",
					{ "class": "main-wrapper-text" },
					Object(preact_min["h"])(
						"h3",
						null,
						props.title
					)
				),
				profile__ref,
				Object(preact_min["h"])(
					"div",
					{ "class": "summary" },
					props.about && Object(preact_min["h"])(
						"h5",
						null,
						props.about.title
					),
					descriptions
				)
			)
		);
	};

	return Profile;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/home/experience.js
var experience__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function experience__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function experience__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function experience__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var formatTime = function formatTime(_ref) {
	var from = _ref.from,
	    to = _ref.to;
	return [from, to].filter(function (val) {
		return val;
	}).join(' - ');
};

var experience_ResumeItem = function (_Component) {
	experience__inherits(ResumeItem, _Component);

	function ResumeItem() {
		experience__classCallCheck(this, ResumeItem);

		return experience__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	ResumeItem.prototype.render = function render(_ref2) {
		var location = _ref2.location,
		    time = _ref2.time,
		    title = _ref2.title,
		    description = _ref2.description;

		var timePeriod = formatTime(experience__extends({}, time));

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'resume-item' },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'qualification' },
				Object(preact_min["h"])(
					'strong',
					null,
					location
				),
				Object(preact_min["h"])(
					'p',
					{ 'class': 'time-period' },
					timePeriod
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': 'summary' },
				Object(preact_min["h"])(
					'strong',
					null,
					title
				),
				Object(preact_min["h"])(
					'p',
					null,
					description
				)
			)
		);
	};

	return ResumeItem;
}(preact_min["Component"]);

var experience_ExperienceItem = function (_Component2) {
	experience__inherits(ExperienceItem, _Component2);

	function ExperienceItem() {
		experience__classCallCheck(this, ExperienceItem);

		return experience__possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	ExperienceItem.prototype.render = function render(_ref3) {
		var title = _ref3.title,
		    list = _ref3.list;

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'resume' },
			Object(preact_min["h"])(
				'h5',
				null,
				title
			),
			list && list.map(function (item) {
				return Object(preact_min["h"])(experience_ResumeItem, item);
			})
		);
	};

	return ExperienceItem;
}(preact_min["Component"]);

var _ref4 = Object(preact_min["h"])('div', { 'class': 'divider' });

var experience_Experience = function (_Component3) {
	experience__inherits(Experience, _Component3);

	function Experience() {
		experience__classCallCheck(this, Experience);

		return experience__possibleConstructorReturn(this, _Component3.apply(this, arguments));
	}

	Experience.prototype.render = function render(props) {
		return Object(preact_min["h"])(
			'section',
			{ 'class': 'experience section', style: { backgroundColor: props.background_color || null } },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'main-wrapper' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'main-wrapper-text' },
					Object(preact_min["h"])(
						'h3',
						null,
						props.title
					)
				),
				props.list && props.list.map(function (item) {
					return Object(preact_min["h"])(
						'div',
						{ 'class': 'experience-item' },
						_ref4,
						Object(preact_min["h"])(experience_ExperienceItem, item)
					);
				})
			)
		);
	};

	return Experience;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/home/skills.js


function skills__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function skills__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function skills__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var skills__ref2 = Object(preact_min["h"])(components_icon, { icon: 'star' });

var skills__ref3 = Object(preact_min["h"])(components_icon, { icon: 'star-o' });

var skills_SkillItem = function (_Component) {
	skills__inherits(SkillItem, _Component);

	function SkillItem() {
		skills__classCallCheck(this, SkillItem);

		return skills__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SkillItem.prototype.render = function render(_ref) {
		var label = _ref.label,
		    value = _ref.value;

		var starsFull = Array(value).fill().map(function (val) {
			return skills__ref2;
		}),
		    starsEmpty = Array(5 - value).fill().map(function (val) {
			return skills__ref3;
		});

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'skillset-item' },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'skill-values' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'skill-name' },
					Object(preact_min["h"])(
						'p',
						null,
						label
					)
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': 'skill-score' },
					starsFull,
					starsEmpty
				)
			)
		);
	};

	return SkillItem;
}(preact_min["Component"]);

var skills__ref4 = Object(preact_min["h"])('div', { 'class': 'divider' });

var skills_Skills = function (_Component2) {
	skills__inherits(Skills, _Component2);

	function Skills() {
		skills__classCallCheck(this, Skills);

		return skills__possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	Skills.prototype.render = function render(props) {
		return Object(preact_min["h"])(
			'section',
			{ 'class': 'skills section', style: { backgroundColor: props.background_color || null } },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'main-wrapper' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'main-wrapper-text' },
					Object(preact_min["h"])(
						'h3',
						null,
						props.title
					)
				),
				skills__ref4,
				props.list && props.list.map(function (item) {
					return Object(preact_min["h"])(skills_SkillItem, item);
				})
			)
		);
	};

	return Skills;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/home/footer.js


function footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function footer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var cvtext = "Download My CV";

var footer_FooterItem = function (_Component) {
	footer__inherits(FooterItem, _Component);

	function FooterItem() {
		footer__classCallCheck(this, FooterItem);

		return footer__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	FooterItem.prototype.render = function render(_ref) {
		var label = _ref.label,
		    link = _ref.link,
		    icon_class = _ref.icon_class;

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'footer-link' },
			Object(preact_min["h"])(
				'a',
				{ href: link, target: '_blank', rel: 'noopener noreferrer' },
				Object(preact_min["h"])(components_icon, { icon: icon_class }),
				' ',
				label
			)
		);
	};

	return FooterItem;
}(preact_min["Component"]);

var footer__ref2 = Object(preact_min["h"])('div', { 'class': 'divider' });

var footer__ref3 = Object(preact_min["h"])('div', { 'class': 'divider' });

var footer__ref4 = Object(preact_min["h"])(
	'a',
	{ href: 'https://www.dropbox.com/s/qe48vd9mkcs9vvu/shaffiullahresume.pdf?dl=0', 'class': 'button large' },
	' ',
	cvtext
);

var footer_Footer = function (_Component2) {
	footer__inherits(Footer, _Component2);

	function Footer() {
		footer__classCallCheck(this, Footer);

		return footer__possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	Footer.prototype.render = function render(props) {
		return Object(preact_min["h"])(
			'footer',
			{ 'class': 'footer', style: { backgroundColor: props.background_color || null } },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'footer-wrapper' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'footer-wrapper-text' },
					Object(preact_min["h"])(
						'h3',
						null,
						props.title
					)
				),
				footer__ref2,
				props.list && props.list.map(function (item) {
					return Object(preact_min["h"])(footer_FooterItem, item);
				}),
				footer__ref3,
				footer__ref4
			)
		);
	};

	return Footer;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/home/index.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function home__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function home__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function home__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var home_Home = function (_Component) {
	home__inherits(Home, _Component);

	function Home() {
		var _temp, _this, _ret;

		home__classCallCheck(this, Home);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = home__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			profile: __webpack_require__("+5hP")
		}, _temp), home__possibleConstructorReturn(_this, _ret);
	}

	Home.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		//				{profile.experience && <Experience {...profile.experience} />}

		Object(unfetch_es["default"])('/profile.json').then(function (response) {
			return response.json();
		}).then(function (profile) {
			return _this2.setState({ profile: profile });
		});
	};

	Home.prototype.render = function render(_ref, _ref2) {
		var profile = _ref2.profile;

		_objectDestructuringEmpty(_ref);

		return Object(preact_min["h"])(
			'div',
			{ itemscope: true, itemprop: 'Person', itemtype: 'https://schema.org/Person' },
			profile.header && Object(preact_min["h"])(header_Header, profile.header),
			profile.profile && Object(preact_min["h"])(profile_Profile, profile.profile),
			profile.contact && Object(preact_min["h"])(footer_Footer, profile.contact)
		);
	};

	return Home;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var app__ref = Object(preact_min["h"])(
	'div',
	{ id: 'app' },
	Object(preact_min["h"])(home_Home, null)
);

var App = function (_Component) {
	app__inherits(App, _Component);

	function App() {
		app__classCallCheck(this, App);

		return app__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	App.prototype.render = function render() {
		return app__ref;
	};

	return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index = __webpack_exports__["default"] = (App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "NfrT":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./shaffi11-large.jpg": "k1am",
	"./shaffi11-medium.jpg": "B7t3",
	"./shaffi11-small.jpg": "DrC8",
	"./shaffi11-xlarge.jpg": "UdZ4",
	"./shaffi11-xsmall.jpg": "ZihT",
	"./shaffi11.jpg": "wTDx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NfrT";

/***/ }),

/***/ "QAmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = typeof fetch == 'function' ? fetch.bind() : function (url, options) {
	options = options || {};
	return new Promise(function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials == 'include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body);

		function response() {
			var _keys = [],
			    all = [],
			    headers = {},
			    header;

			request.getAllResponseHeaders().replace(/^(.*?):\s*([\s\S]*?)$/gm, function (m, key, value) {
				_keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? header + "," + value : value;
			});

			return {
				ok: (request.status / 200 | 0) == 1, // 200-299
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function text() {
					return Promise.resolve(request.responseText);
				},
				json: function json() {
					return Promise.resolve(request.responseText).then(JSON.parse);
				},
				blob: function blob() {
					return Promise.resolve(new Blob([request.response]));
				},
				headers: {
					keys: function keys() {
						return _keys;
					},
					entries: function entries() {
						return all;
					},
					get: function get(n) {
						return headers[n.toLowerCase()];
					},
					has: function has(n) {
						return n.toLowerCase() in headers;
					}
				}
			};
		}
	});
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=unfetch.es.js.map

/***/ }),

/***/ "UdZ4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c5fdd6e71524d05f6df5791e56f6b09b.jpg";

/***/ }),

/***/ "ZihT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "75a39980e1e34f71f009fd49050f075c.jpg";

/***/ }),

/***/ "k1am":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9342b4baf2892c45ca901a74eca2448c.jpg";

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "wTDx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "50fd6bc4be51c20842b7e288ffe11f90.jpg";

/***/ }),

/***/ "yY49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.cdf6a.js